import { withSpaContainer, type SpaContainerProps } from '@nab/x-spa-react';
import { createUI } from '@nab/nui-react';

export const ShellContainer = createUI<SpaContainerProps>([withSpaContainer]);
